import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../styles.css';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setError('Invalid or missing reset token.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      setLoading(false);
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL.endsWith('/')
        ? process.env.REACT_APP_API_URL.slice(0, -1)
        : process.env.REACT_APP_API_URL;
      const res = await axios.post(`${apiUrl}/api/auth/reset-password`, {
        token,
        newPassword,
      });
      console.log('Reset password response:', res.data);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000); // Redirect to login after 2 seconds
    } catch (err) {
      console.error('Reset password error:', err.response?.data || err.message);
      setError(err.response?.data?.error || 'An error occurred while resetting the password.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="page-container auth-page">
        <section className="content-container container my-4">
          <div className="login-card p-4 mx-auto card-max-width">
            <h2 className="text-center mb-4">Password Reset</h2>
            <p className="text-success text-center">Password reset successfully! Redirecting to login...</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="page-container auth-page">
      <section className="content-container container my-4">
        <div className="login-card p-4 mx-auto card-max-width">
          <h2 className="text-center mb-4">Reset Password</h2>
          {error && <p className="text-danger text-center">{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="New Password"
                required
                minLength={8} // Add basic password validation
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm New Password"
                required
                minLength={8}
              />
            </div>
            <button type="submit" className="btn btn-primary w-100" disabled={loading || !token}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
